module.exports = __webpack_public_path__ + "img/Snare_Sub.4bae1dde.jpg";